const __request = require(`./__request/__request_contentType_json`);

// 航变订单
const recordCount = (data) => {
let pParameter = {
    method: 'post',
    // urlSuffix: '/flight/domestic/buyer/manage/order/airborneList',
    urlSuffix:'/buyer/dom/manage/AirChangeList',
    data:data
  }

  return __request(pParameter)
}
export default recordCount
